const workspaces = {
  add_new: 'Add workspace',
  add_new_workspace: 'Add new workspace',
  title: 'Title',
  title_placeholder: 'Workspace title',
  description_placeholder: 'Describe the workspace in a few words',
  settings: 'Settings',
  users: 'Users',
  delete: 'Delete workspace',
  create: 'Create a workspace',
  no_active: 'No active workspaces',
  no_active_info:
    'Create your first workspace or ask colleagues to invite you to existing one',
  workspace: 'Workspace',
  branch_name: 'Branch name',
  workspace_placeholder: 'Enter workspace',
  repository_placeholder: 'Enter repository',
  branch_name_placeholder: 'Enter branch name',
  no_repository_connected: 'No repository connected',
  remove_publication_settings: 'Remove publication settings',
  remove_publication_settings_text:
    'Do you really want to remove these publication settings?',
  change_publishing_output_text: 'The publishing output can be changed in',
  change_publishing_output_link: 'workspace settings',
  no_workspaces: 'You do not have any workspaces',
  add_first: 'Add first',
  open_in_plugin: 'Please open your workspace in Figma plugin.',
  validation: {
    title_cannot_be_empty: "Workspace title can't be empty",
    title_too_short:
      'Workspace title name must have at least {{minLength}} characters',
    title_too_long:
      'Workspace title name must be no longer than {{maxLength}} characters',
    access_token_cannot_be_empty: "Access token can't be empty",
    access_token_too_short:
      'Access token name must have at least {{minLength}} characters',
    access_token_too_long:
      'Access token name must be no longer than {{maxLength}} characters',
    repository_cannot_be_empty: "Repository can't be empty",
    repository_too_short:
      'Repository name must have at least {{minLength}} characters',
    repository_too_long:
      'Repository name must be no longer than {{maxLength}} characters',
    workspace_cannot_be_empty: "Workspace can't be empty",
    workspace_too_short:
      'Workspace name must have at least {{minLength}} characters',
    workspace_too_long:
      'Workspace name must be no longer than {{maxLength}} characters',
    branch_name_cannot_be_empty: "Branch name can't be empty",
    branch_name_too_short:
      'Branch name name must have at least {{minLength}} characters',
    branch_name_too_long:
      'Branch name name must be no longer than {{maxLength}} characters',
    description_too_long:
      'Workspace description must be no longer than {{maxLength}} characters',
    output_adapter_cannot_be_empty: "Output adapter can't be empty",
    output_adapter_is_not_valid: 'Output adapter is not valid',
    identifier_cannot_be_empty: "Workspace identifier can't be empty",
    identifier_is_not_valid:
      'Workspace identifier is not valid, only small letters and "-" are acceptable',
    identifier_too_short:
      'Workspace identifier must have at least {{minLength}} characters',
    identifier_too_long:
      'Workspace identifier must be no longer than {{maxLength}} characters',
  },
  errors: {
    cannot_save_publishing_settings: 'Cannot save publishing settings',
    cannot_save_repository_settings: 'Cannot save repository settings',
    cannot_remove_publishing_settings: 'Cannot remove publishing settings',
  },
} as const;

export default workspaces;
